import { render } from "./CancellationCause.vue?vue&type=template&id=b310375a&scoped=true"
import script from "./CancellationCause.vue?vue&type=script&lang=js"
export * from "./CancellationCause.vue?vue&type=script&lang=js"

import "./CancellationCause.vue?vue&type=style&index=0&id=b310375a&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b310375a"]])

export default __exports__